import { Injectable } from '@angular/core';
import { environment } from '@d-environments/environment';
import { BaseSearchRequest } from '@d-models';
import { HttpService } from '@d-services/other/http.service';
import { CoreHttpService } from './core-http.service';

@Injectable()
export class MerchantCoreService {
  private apiUrl: string = environment.API_URL;

  constructor(
    private httpService: HttpService,
    private coreHttp: CoreHttpService,
  ) {}

  buildCoreSearchBody(body: any) {
    const {
      pageIndex,
      pageSize,
      sortBy,
      searchGlobal,
      advancedFilter,
      statuses,
    } = body;
    const filter: any = advancedFilter || {};
    if (searchGlobal.filterBy && searchGlobal.searchBy) {
      filter[searchGlobal.filterBy] = searchGlobal.searchBy;
    }
    filter.status = advancedFilter?.['status'] ?? statuses?.[0];
    const sort =
      sortBy?.map((sort: any) => ({
        field:
          sort.fieldName.charAt(0)?.toLowerCase() + sort.fieldName.slice(1),
        asc: sort.ascending,
      })) || [];
    return {
      pageIndex: pageIndex - 1,
      pageSize,
      sort,
      filter: Object.entries(filter)
        .filter(([_, v]) => v !== null && v !== undefined)
        .map(([key, value]) => ({
          field: key,
          valueString: value,
        })),
    };
  }

  searchMerchant(request: BaseSearchRequest, { headers = {} } = {}) {
    const body = this.buildCoreSearchBody(
      this.httpService.buildSearchRequest(request),
    );
    return this.coreHttp.post<[]>('Merchant/GetAllByPaging', body, {
      headers,
      useTenantCompanyId: false,
    });
  }
}
